module.exports = __webpack_public_path__ + "static/media/convertir_artista_linea_1.c516d06a.svg";